import { useEffect } from 'react';
import { useUserSelection } from '../Contexts/useUserSelection';
import { DroneLayersList } from '../Services/apiResponseInterfaces';

interface FilteredDroneLayersProps {
    droneLayerList: any[];
    setFilteredDroneLayerList: React.Dispatch<React.SetStateAction<DroneLayersList[]>>;
}

const useFilteredDroneLayers = ({ droneLayerList, setFilteredDroneLayerList }: FilteredDroneLayersProps) => {
    const { selectedYear } = useUserSelection();

    useEffect(() => {
        if (!droneLayerList.length) return;

        let targetYear = selectedYear;

        if (!targetYear) {
            targetYear = Math.max(...droneLayerList.flatMap(layer =>
                layer.layers.map((subLayer: any) => new Date(subLayer.date_str).getFullYear())
            ));
        }

        const filteredList = droneLayerList.map(layer => ({
            ...layer,
            layers: layer.layers.filter((subLayer: any) => new Date(subLayer.date_str).getFullYear() === targetYear)
        })).filter(layer => layer.layers.length > 0);

        setFilteredDroneLayerList(filteredList);
    }, [selectedYear, droneLayerList, setFilteredDroneLayerList]);
};

export default useFilteredDroneLayers;
